import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ─────────────────────────────────────────────────────────────────────────────
// SURFACE SELECTION — owner ruling 2026-07-31, option B: query param, same origin.
//
//   http://<host>:3000            → the landscape desktop (default, unchanged)
//   http://<host>:3000/?surface=phone → the portrait surface
//
// The surface switch is NOT here. It is inside App, immediately after the PIN
// gate, because the session token exists only in an AUTHENTICATED document's
// memory (server/app.py:2133 — header-only auth, never localStorage).
//
// This file previously REDIRECTED ?surface=phone to /phone/. That was the bug:
// the redirect handed the design document its own fresh, token-less window, so
// all nine feeds went out unauthenticated and every panel read unavailable.
// Both surfaces now boot through exactly this one path.
// ─────────────────────────────────────────────────────────────────────────────
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
